export default "__VITE_ASSET__d2b800d7__"